import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-254" data-mp="30xq6vhilcqwd">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-255" data-mp="2w56qydwfljoe">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-256" data-mp="2r7wvagig8bs4">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-257" data-mp="2r5kbryx1ltcy">
            Czy to Ci się zdarza?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-258" data-mp="2i5nkdpj9qge7">
            Jeśli odpowiesz «tak» choć na jedno pytanie, AQUAAEROBIK GOTOWY™ jest dla Ciebie.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-259" data-mp="289c6ww7xzki6">
            Zasługujesz na prostszy sposób
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-260" data-mp="6hpcekoud7gy" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-261" data-mp="3nn70w6en86ff">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-262" data-mp="3elzccg1xijyj">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-263" data-mp="3em92q4qvyt4r">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-264" data-mp="b50pjy73shgd" />
                </span>
                <div data-id="element-265" data-mp="3slrzk1e8yi1r">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-266" data-mp="3sma6bryjcenx">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-267" data-mp="1exkgzmpjd1o">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}